
    <ng-select
      [(ngModel)]="value"
      [items]="options$ | async"
      appendTo="body"
      bindLabel="text"
      class="fieldmagic-data-grid-dropdown"
      [clearable]="clearable$ | async"
      [multiple]="multi$ | async"
      [placeholder]="placeholder$ | async | translate"
      [matTooltip]="tooltip$ | async"
      (ngModelChange)="onChanged()"
    >
      <!-- displayed for the selected dropdown option -->
      <ng-template
        ng-label-tmp
        let-item="item"
        let-clear="clear"
      >
        <span class="ng-value-label">{{ item.text | translate }}</span>
        <span
          *ngIf="multi$ | async"
          class="ng-value-icon right selected-close"
          (click)="clear(item)"
          innerText="x"
        >
        </span>
      </ng-template>

      <!-- displayed for the dropdown options -->
      <ng-template
        ng-option-tmp
        let-item="item"
      >
        <span class="ng-value-label">{{ item.text | translate }}</span>
      </ng-template>

      <!-- displayed for results found: only when customizable is enabled -->
      <ng-template
        let-searchTerm="searchTerm"
        ng-notfound-tmp
      >
        <span
          *ngIf="(customizable$ | async) && (searchTerm | filled)"
          class="ng-option"
          (click)="onNewCustomizedOption(searchTerm)"
        >
          {{ 'Add new item for "%s"' | translate | sprintf : [searchTerm] }}
        </span>

        <span
          *ngIf="searchTerm | blank"
          class="ng-option disabled"
          [innerText]="'No items found' | translate"
        >
        </span>
      </ng-template>
    </ng-select>
  